import React, { useState, useEffect, useContext, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { api } from '../../api/index';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
import Navbar from '../navbar/Navbar';
import AdBanner from '../ad_banner/AdBanner';
import GoogleReviewCard from './GoogleReviewIcon';

import './googlereview.css';

const GoogleReview = () => {
  const [timeLeft, setTimeLeft] = useState(15); // initial countdown
  const [isValidUrl, setIsValidUrl] = useState(false); // Track URL validity
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const { response, setResponse, deck } = useContext(AppContext);
  
  // Filter slide with type = "google_review"
  const filteredDeck = deck.filter((slide) => slide.type === 'google_review');
  const filteredSlide = filteredDeck.length ? filteredDeck[0] : null;
  const background_color = filteredSlide?.background_color ?? '#fafafa';

  const googleReviewUrl = localStorage.getItem('google_review_url');

  // Validate Google Review URL on component mount
  useEffect(() => {
    const validateGoogleReviewUrl = () => {
      // Check if URL exists and is not null, undefined, empty, or just whitespace
      if (!googleReviewUrl || 
          googleReviewUrl.trim() === '' || 
          googleReviewUrl === 'null' || 
          googleReviewUrl === 'undefined') {
        console.log('Invalid google_review_url detected, redirecting to /question1');
        navigate('/question1');
        return false;
      }
      return true;
    };

    const isValid = validateGoogleReviewUrl();
    setIsValidUrl(isValid);
    
    // Only start timer if URL is valid
    if (isValid) {
      startTimer(timeLeft);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []); // Run only on mount

  // Set up countdown and redirect
  useEffect(() => {
    // Only set up timer if URL is valid
    if (isValidUrl) {
      return () => {
        if (timerRef.current) clearInterval(timerRef.current);
      };
    }
  }, [isValidUrl]);

  // Start or restart the timer
  const startTimer = (duration) => {
    if (timerRef.current) clearInterval(timerRef.current);
    setTimeLeft(duration);

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 1) {
          clearInterval(timerRef.current);
          navigate('/question1');
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Extend time by 10 more seconds
  const extendTime = () => {
    startTimer(timeLeft + 10);
  };

  // Don't render anything if URL is invalid (component will redirect)
  if (!isValidUrl) {
    return null;
  }

  return (
    <div className='google-review-page-container' style={{ backgroundColor: background_color }}>
      <Navbar />
      <div className='google-review-container'>
        <div className='google-review-title-main-title'>Thank you for your feedback!</div>
        <div className='google-review-title'>
          <p>We appreciate your feedback and would love to hear more about your experience.</p>
          <p>Please take a moment to leave a review on Google by scanning the QR code below.</p>
        </div>
        <GoogleReviewCard />
        {googleReviewUrl && <QRCodeSVG value={googleReviewUrl} className='qrcode'/>}
        <p className='google-review-countdown'>
          Returning to home in <strong>{timeLeft}</strong> seconds...
        </p>
        <button
          onClick={extendTime}
          className='google-review-more-time-btn'
        >
          Need more time?
        </button>
      </div>
      <AdBanner />
    </div>
  );
};

export default GoogleReview;